<template>
  <div class="api-keys-tab">
    <ApiTabEmptyState
      title="No API keys yet"
      description="Create a personal key to authenticate requests to the Crossbeam API. Usage, scopes, and rate limits will appear here once a key exists."
      create-cta-text="Create API key"
      :icon="['fak', 'lock']"
    />
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue';

import ApiTabEmptyState from '../components/ApiTabEmptyState.vue';

useHead({ title: 'API Keys - Crossbeam' });
</script>
